//import * as test from './js/SquareText.js'
const Random = Phaser.Math.Between

import {GAMEOPTIONS} from '../scene/GameOption.js'
import BlockNumber from '../scene/prefabs/blocknumber.js'
import Block from '../scene/prefabs/block.js'
import CustomText from '../scene/prefabs/customtext.js'
import Tween from './prefabs/tween.js'
import Popup from './popup/PopupHammer.js'
import axios from 'axios';
import eventBus from '@/plugins/event-bus';

//const {randomInt} = require('node:crypto').webcrypto;

let isDesktop = false;
let fieldArray;
let fieldGroup;
let groupBlock = [];
let groupBoder = [];
let grBlockNumber;
let grObjMerge = [];
let countNextTurn = 0;
let selectBn = false;
let bnIsMoving = false;
let isMerging = false;
let startFill = false;
let txtHightScore, txtDiamond;
let totalScore = 0;
let txtScore, txtTotalScore;
let score = 0;
let number_diamond = 0;
let hightScore = 0;
let b;
let tw, popup;

eventBus.on('isDesktop', async (data) => {
    isDesktop = true;
});

const headers = {
    'Content-Type': 'application/json',
    "User-Agent": "SmartHoldem",
};

let use_hammer = false
let check_sound = true

let lstValue = [2, 4, 8, 16, 32, 64, 128, 256, 512]
let lstColor = ['0x916BBF', '0xFFA500', '0xF14668', '0x77D970', '0x1597E5', '0x396EB0', '0xB8405E', '0x39A388', '0x325288']
let gameData = {
    values: GAMEOPTIONS.value,
    color: GAMEOPTIONS.colors,
}

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

let step = 0;


let userId = localStorage.getItem('uid') || '260652640'
const partner_id = localStorage.getItem('partner_id') || '';
let tg = window.Telegram.WebApp; //получаем объект webapp телеграма
let name = 'Guest';


//console.log('partner_id', partner_id)

function resetValues() {
    fieldArray = null;
    fieldGroup = null;
    groupBlock = []
    groupBoder = []
    grBlockNumber = null
    grObjMerge = []
    countNextTurn = 0
    selectBn = false
    bnIsMoving = false
    isMerging = false
    startFill = false
    txtHightScore = ''
    txtDiamond = '0'
    txtScore = '0'
    score = 0
    number_diamond = 0
    hightScore = 0
    b = null
    tw = null
    popup = null
    use_hammer = false
    lstValue = [2, 4, 8, 16, 32, 64, 128, 256, 512]
    lstColor = ['0x916BBF', '0xFFA500', '0xF14668', '0x77D970', '0x1597E5', '0x396EB0', '0xB8405E', '0x39A388', '0x325288']
    step = 0;

    check_sound = !localStorage.getItem('isSoundOff')

    if (tg.initData) {
        tg.expand(); //расширяем на все окно
        userId = tg.initDataUnsafe.user.id;
        name = tg.initDataUnsafe.user.first_name;
        try {
            axios.post(GAMEOPTIONS.API + '/user-login', {
                uid: userId,
                partner_id: partner_id,
                data: tg.initDataUnsafe,
                initData: tg.initData,
            }).then(function (data) {
                //console.log(data.data)
                localStorage.setItem('address', data.data['address'])
                totalScore = data.data['totalScore'];
                localStorage.setItem('totalScore', data.data['totalScore']);
                localStorage.setItem('lang', data.data['lang'] || 'en');
            });

        } catch (e) {
            console.log('err connection')
        }
        localStorage.setItem('uid', userId);
        localStorage.setItem('name', name)
        //tg.sendData("some string that we need to send");
    }

    try {
        axios.get(GAMEOPTIONS.API + '/new-game/' + userId).then(function (data) {
            gameData = data.data;
            totalScore = data.data['totalScore'];
            localStorage.setItem('totalScore', gameData['totalScore']);
            //console.log('gameData', gameData)
        });
    } catch (e) {
        totalScore = 0;
        console.log('err new-game, no connection')
    }


}

export default class GamePlay extends Phaser.Scene {
    constructor() {
        super({key: 'game_play'})
    }

    async create() {
        resetValues();
        //вместо ниже условий
        localStorage.setItem('diamond', GAMEOPTIONS.START_DIAMOND)
        if (localStorage.getItem('hscore') === undefined) localStorage.setItem('hscore', 0)

        tw = new Tween()
        popup = new Popup()
        this.bg = this.add.tileSprite(this.scale.width / 2, this.scale.height / 2, this.scale.width, this.scale.height, 'bg2')
        this.bg.alpha = 0.5

        lstValue = [2, 4, 8, 16, 32, 64, 128, 256, 512]
        lstColor = ['0x916BBF', '0xFFA500', '0xF14668', '0x77D970', '0x1597E5', '0x396EB0', '0xB8405E', '0x39A388', '0x325288']

        selectBn = true
        CreateGrid(this)
        createBorderBlock(this)
        await CreateBlockNumber(this)

        //Create UI
        UIDiamond(this)
        UIHigthScore(this)
        setTimeout(() => {
            totalScore = localStorage.getItem('totalScore')
            txtTotalScore.updateText(numberFormat(totalScore))
        }, 1000);

        UIScore(this);
        UIItem(this);
        UISound(this);


        eventBus.on('unPause', async (data) => {
            try {
                this.scene.resume('game_play');
            } catch (e) {
                console.log('err. unPause')
            }
        });

    }


    tileDestination(pos) {
        const a = pos * (GAMEOPTIONS.tileSize + GAMEOPTIONS.tileSpacing) + GAMEOPTIONS.tileSize / 2 + GAMEOPTIONS.tileSpacing + 100
        return a
    }

    update() {
        this.bg.tilePositionX -= 0.5

        if (!isMerging && startFill && grObjMerge.length === 0) {
            FindAll(this)
        }
    }
}



export function DeactivePopup() {
    use_hammer = false
    startFill = true
}

function showGameOver(scene) {
    // Add overlay rectangle:
    let graphics = scene.add.graphics();
    // setColor method sets the fill color
    // 0x prefix indicates it's a hexadecimal color, and 0x000000 is black
    graphics.fillStyle(0x000000, 0.8); // 0.5 is for transparency
    graphics.lineStyle(3, 0x00e0bf, 1);
    graphics.strokeRect(90, 215, scene.scale.width - 165, scene.scale.height - 520);
    let rect = graphics.fillRect(90, 215, scene.scale.width - 165, scene.scale.height - 520);

    const textGameOver = new CustomText(scene, scene.scale.width / 2, scene.scale.height / 2 - 315, 'popin', 'OUT OF MOVIES!', 60)

    const logo = scene.add.image(scene.scale.width / 2, scene.scale.height / 2 - 75, "logo").setScale(0.8);

    const tw1 = new Tween()
    let btnPlay = scene.add.image(0, 640, "btnPlay").setScale(1, 0.9).setInteractive()
    btnPlay.on('pointerdown', function (pointer) {
        // Tween.tween(scene,btnPlay,'btnPlay')
        tw1.BtnClickAnim(scene, btnPlay, 'btnPlay')
        //resetValues();
        scene.scene.restart('game_play');
    })
    tw1.ObjectMove(scene, btnPlay, scene.scale.width / 2, scene.scale.height / 2 + 230)
}

function CreateGrid(scene) {
    fieldArray = [];
    fieldGroup = scene.add.group();

    for (let i = 0; i < GAMEOPTIONS.row; i++) {
        fieldArray[i] = [];
        for (let j = 0; j < GAMEOPTIONS.colum; j++) {
            let block = scene.add.image(scene.tileDestination(j), scene.tileDestination(i) + 125, "block").setScale(0.5)
            block.alpha = 0.3;
            block.tint = '0x6e85d8'
            block.visible = 1;
            block.setDataEnabled();
            block.data.set('i', i)
            block.data.set('j', j)

            if (i === 7) {
                block.tint = '0x6e85d8'
                block.alpha = 0;
            }
            block.setInteractive().on('pointerdown', function () {
                GetBlockIndex(this.scene, this)
            });
            fieldGroup.add(block);
            fieldArray[i][j] = {
                tileNumber: null,
                tile: block,
                tileValue: 0,
                //canMerge:true
            }
        }
    }
}

function createBorderBlock(scene) {
    groupBoder = []
    let pos = scene.scale.width / 2;//370; //260
    /*
    for (let i = 0; i < 3; i++) {
        let boder = new Block(scene, pos, 1100, 'boder').setScale(0.5)
        // boder.setInteractive().on('pointerdown', function () { SelectBlock(scene, this) });
        boder.alpha = 0.3
        groupBoder.push(boder)
        pos += 110
    }

     */

    //pos += 110
    let boder = new Block(scene, pos, 1080, 'boder').setScale(0.5)
    // boder.setInteractive().on('pointerdown', function () { SelectBlock(scene, this) });
    boder.alpha = 0.3
    groupBoder.push(boder)

}

async function CreateBlockNumber(scene) {
    let pos = scene.scale.width / 2;  //260 + 110;
    //mainnetawait delay(300)
    let r = Random(1, 100)
    if (r > 0 && r <= 20) r = 0; //2
    if (r > 20 && r <= 40) r = 1; //4
    if (r > 40 && r <= 60) r = 2; //8
    if (r > 60 && r <= 70) r = 3; //16
    if (r > 70 && r <= 80) r = 4; //32
    if (r > 80 && r <= 100) r = 5; //64
    if (r > 90 && r <= 93) r = 6; //128
    if (r > 93 && r <= 96) r = 7; //256
    if (r > 96 && r <= 100) r = 8; //512
    /*
    for (let i = 0; i < 1; i++) {
        await delay(300)
        let r = Random(1, 100)
        if (r > 0 && r <= 20) r = 0; //2
        if (r > 20 && r <= 40) r = 1; //4
        if (r > 40 && r <= 60) r = 2; //8
        if (r > 60 && r <= 70) r = 3; //16
        if (r > 70 && r <= 80) r = 4; //32
        if (r > 80 && r <= 100) r = 5; //64
        if (r > 90 && r <= 93) r = 6; //128
        if (r > 93 && r <= 96) r = 7; //256
        if (r > 96 && r <= 100) r = 8; //512

        countNextTurn++
        //console.log('rand', r, lstValue[r])
        let block = NewBlock(scene, 0, 0, 'block', lstColor[r], lstValue[r], pos)
        block.setSize(100, 100)
        block.setInteractive().on('pointerdown', function () {
            SelectBlock(scene, this)
        });
        block.setDataEnabled()
        block.data.set('id', i)
        block.data.set('can_select', true)
        block.data.set('value', lstValue[r])
        groupBlock.push(block)

        scene.tweens.add({
            targets: block,
            scale: {from: 0.5, to: 0.95},
            ease: 'Elastic',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
            duration: 1500,
            repeat: 0,            // -1: infinity
        });
        //pos += 110

    }
*/


    /*
    try {
        const gameData = (await axios.get(GAMEOPTIONS.API + '/rand/' + uid, {
            //headers
        })).data;
        //await delay(300);
        r = gameData['index'];
    } catch (e) {

    }

     */


    countNextTurn++;
//    console.log('lstValue', lstValue)
    let block = NewBlock(scene, 0, 0, 'block', lstColor[r], lstValue[r], pos)
    block.setSize(100, 100)
    block.setInteractive().on('pointerdown', function () {
        SelectBlock(scene, this)
    });
    block.setDataEnabled()
    block.data.set('id', 0)
    block.data.set('can_select', true)
    block.data.set('value', lstValue[r])
    groupBlock.push(block)

    scene.tweens.add({
        targets: block,
        scale: {from: 0.5, to: 0.95},
        ease: 'Elastic',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
        duration: 1500,
        repeat: 0,            // -1: infinity
    });

    //console.log(gameData)


}

function NewBlock(scene, x, y, img, tint, txtValue, pos) {
    let bn = scene.add.image(x, y, img).setScale(0.4)
    bn.tint = tint

    if (txtValue > 1000 && txtValue < 1000000) {
        txtValue = Math.trunc(txtValue / 1000) + "K"

    }
    if (txtValue > 1000000 && txtValue < 1000000000) {
        txtValue = Math.trunc(txtValue / 1000000) + 'M'
    }

    if (txtValue > 1000000000 && txtValue < 1000000000000) {
        txtValue = Math.trunc(txtValue / 1000000000) + 'B'
    }

    if (txtValue > 1000000000000) {
        txtValue = Math.trunc(txtValue / 1000000000000) + 'T'
    }

    let fontSize = 43;

    if (txtValue.toString().length > 2) {
        fontSize = 38;
    }

    if (txtValue.toString().length > 3) {
        fontSize = 34;
    }

    let text = new CustomText(scene, bn.x, bn.y, 'popin', txtValue, fontSize)
    let shadow = scene.add.image(bn.x, bn.y, "shadow").setScale(0.4).setAngle(180)
    shadow.alpha = 0
    let block = scene.add.container(pos, 1080, [bn, text, shadow]);
    return block
}

function SelectBlock(scene, bn) {
    if (use_hammer) {
        if (number_diamond >= 150) {
            fieldArray[bn.data.get('i')][bn.data.get('j')].tileValue = 0
            startFill = true
            use_hammer = false
            popup.Deactive()
            number_diamond = number_diamond - 150
            //localStorage.setItem('diamond', number_diamond)
            txtDiamond.updateText(number_diamond)
            let tint = bn.first.tint
            scene.add.particles(0, 0, 'block', {
                x: bn.x,
                y: bn.y,
                speed: {min: -600, max: 600},
                alpha: {min: 0, max: 0.5},
                angle: {min: 0, max: 360},
                scale: {start: 0.3, end: 0},
                blendMode: 'SCREEN',
                //active: false,
                frequency: 5,
                lifespan: 600,
                gravityY: 800,
                quantity: 5,
                color: [tint],
                // tint: tint,
                maxParticles: 15
            });
            SoundPlay(scene, 'breaking')
            DestroyObj(bn)

        } else {
            popup.UpdateTextMess()
            use_hammer = false
        }
    } else {
        if (bn.data.get('can_select') === false) return
        b = bn
        groupBoder.forEach(element => {
            element.alpha = 0.3
        });
        groupBoder[bn.data.get('id')].alpha = 1

    }

}

function GetBlockIndex(scene, block) {
    //обработка 3х новых чисел она теперь не нужна
    if (selectBn) bnIsMoving = true

    let a = fieldArray[7][block.data.get('j')].tile
    let c = getEndObject(block.data.get('j'), b, scene)


    if (b != null && c != null) {
        /*
        countNextTurn--
        if (countNextTurn === 0) {
            CreateBlockNumber(scene)
        }
         */
        CreateBlockNumber(scene)

        b.setPosition(a.x, a.y)

        MoveObject(scene, b, c.tile)
    } else {
        bnIsMoving = false
    }


}

function getEndObject(colum, bn, scene) {
    let e;
    for (let i = 0; i < GAMEOPTIONS.row; i++) {
        if (fieldArray[i][colum].tileValue === 0 && i < 7) {
            e = fieldArray[i][colum]
            return e
        }
        if (i === 7) {
            let tile = fieldArray[6][colum].tile
            if (fieldArray[6][colum].tileValue === bn.data.get('value')) {

                countNextTurn--
                if (countNextTurn === 0) {
                    CreateBlockNumber(scene);
                }

                const index = groupBlock.indexOf(bn);

                if (index > -1) { // only splice array when item is found
                    groupBlock.splice(index, 1); // 2nd parameter means remove one item only
                }
                bn.destroy()
                let v = Math.log2(fieldArray[6][colum].tileNumber.data.get('value'))
                console.log('tileNumber', fieldArray[6][colum].tileNumber.data.get('value'))

                v = Math.pow(2, v + 1)

                UpdateValueBn(scene, fieldArray[6][colum].tileNumber, fieldArray[6][colum].tile, v)
                //return e
            }
        }
    }
}


function MoveObject(scene, bn, endObj) {
    // console.log(bn)
    // console.log(endObj)

    isMerging = true
    bnIsMoving = true
    groupBoder.forEach(element => {
        element.alpha = 0.3
    });

    let t = scene.tweens.getTweensOf(bn);
    if (t.length > 0) {
        t[0].remove()
    }
    scene.tweens.add({
        targets: bn,
        y: {from: bn.y, to: endObj.y},
        ease: 'Linear',
        duration: 150,
        onComplete: function () {
            const index = groupBlock.indexOf(bn);
            if (index > -1) { // only splice array when item is found
                groupBlock.splice(index, 1); // 2nd parameter means remove one item only
            }

            bn.setScale(1.15)
            b = null
            fieldArray[endObj.data.get('i')][endObj.data.get('j')].tileNumber = bn
            fieldArray[endObj.data.get('i')][endObj.data.get('j')].tileValue = bn.data.get('value');


            let shadow = bn.last;
            shadow.alpha = 0.5
            bn.data.set('can_select', false)
            bn.data.set('i', endObj.data.get('i'))
            bn.data.set('j', endObj.data.get('j'))

            setTimeout(function () {
                shadow.alpha = 0
            }, 300)
            createParticel(scene, bn)
            checkMerge(scene, endObj)
        }
    });

}

function canMerge(obj) {
    let i = obj.data.get('i')
    let j = obj.data.get('j')
    if (i <= 0) return true
    if (topObj(i, j).tileValue > 0) return true
    return false
}

function checkMerge(scene, endObj) {
    isMerging = true
    grObjMerge = []
    let i = endObj.data.get('i')
    let j = endObj.data.get('j')
    let bn = fieldArray[i][j]


    //check top
    if (i > 0) {
        let top = topObj(i, j)
        if (bn.tileValue === top.tileValue) {
            top.tileValue = 0
            grObjMerge.push(top.tileNumber)
        }
    }

    //check left
    if (j > 0) {

        let left = leftObj(i, j)
        if (left != null) {
            if (bn.tileValue === left.tileValue) {
                left.tileValue = 0
                grObjMerge.push(left.tileNumber)
            }
        }
    }

    //check right
    if (j < GAMEOPTIONS.colum - 1) {
        let right = rightObj(i, j)
        if (right != null) {
            if (bn.tileValue === right.tileValue) {
                right.tileValue = 0
                grObjMerge.push(right.tileNumber)
            }
        }
    }

    MergeObj(scene, bn.tileNumber, endObj);

    /*
    let userLine = [];
    for (let i = 0; i < fieldArray.length; i++) {
        userLine = [];
        for (let j = 0; j < fieldArray[i].length; j++) {
            userLine.push(fieldArray[i][j].tileValue);
        }
        console.log('>>>', i, userLine);
    }
    */
}

function MergeObj(scene, bn, endObj) {
    let i = endObj.data.get('i')
    let j = endObj.data.get('j')
    if (grObjMerge.length === 0) {
        SoundPlay(scene, 'drop')
        isMerging = false
        bnIsMoving = false
        selectBn = false
        if (checkGameOver(scene)) {
            try {
                axios.post(GAMEOPTIONS.API + '/game-over/', {
                    uid: userId,
                }).then(function (data) {

                });
            } catch (e) {
                console.log('err. MergeObj. Err connect')
            }

            console.log(' game over')
        }
        return
    }

    let t = scene.tweens
    let v = Math.log2(bn.data.get('value'))


    v = Math.pow(2, v + grObjMerge.length);
    bn.data.set('value', v)
    fieldArray[i][j].tileValue = v
    for (const e of grObjMerge) {
        t.add({
            targets: e,
            x: {from: e.x, to: bn.x},
            y: {from: e.y, to: bn.y},
            ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
            duration: GAMEOPTIONS.timeMerge,
            onComplete: function () {
                SoundPlay(scene, 'merge')
                SaveDiamond(scene, bn.x, bn.y)

                const index = grObjMerge.indexOf(e);
                if (index > -1) { // only splice array when item is found
                    grObjMerge.splice(index, 1); // 2nd parameter means remove one item only
                }
                DestroyObj(e)
            }
        })
    }


    setTimeout(function () {
        isMerging = false
        startFill = true
        UpdateValueBn(scene, bn, endObj, v)
    }, GAMEOPTIONS.timeMerge * grObjMerge.length);
}

function DestroyObj(e) {
    e.destroy()
}

async function UpdateValueBn(scene, bn, obj, v) {
    //console.log('UpdateValueBn')
    let i = obj.data.get('i')
    let j = obj.data.get('j')
    let v_show = 0
    bnIsMoving = false
    selectBn = false
    // если значение больше max обновить массив, сместить
    if (v > lstValue[lstValue.length - 1]) {
        lstValue.shift()
        lstValue.push(v)
        let color = lstColor[0]
        lstColor.shift()
        lstColor.push(color)
        //console.log('new values', lstValue)
        SoundPlay(scene, 'level_up')
    }


    /*
[8, 16, 32, 64, 128, 256, 512, 1024, 2048]
['0xF14668', '0x77D970', '0x1597E5', '0x396EB0', '0xB8405E', '0x39A388', '0x325288', '0x916BBF', '0xFFA500']

[16, 32, 64, 128, 256, 512, 1024, 2048, 4096]
['0x77D970', '0x1597E5', '0x396EB0', '0xB8405E', '0x39A388', '0x325288', '0x916BBF', '0xFFA500', '0xF14668']

[32, 64, 128, 256, 512, 1024, 2048, 4096, 8192]
['0x1597E5', '0x396EB0', '0xB8405E', '0x39A388', '0x325288', '0x916BBF', '0xFFA500', '0xF14668', '0x77D970']

[64, 128, 256, 512, 1024, 2048, 4096, 8192, 16384]
['0x396EB0', '0xB8405E', '0x39A388', '0x325288', '0x916BBF', '0xFFA500', '0xF14668', '0x77D970', '0x1597E5']

[128, 256, 512, 1024, 2048, 4096, 8192, 16384, 32768]
['0xB8405E', '0x39A388', '0x325288', '0x916BBF', '0xFFA500', '0xF14668', '0x77D970', '0x1597E5', '0x396EB0']

[256, 512, 1024, 2048, 4096, 8192, 16384, 65536, 131072]
['0x39A388', '0x325288', '0x916BBF', '0xFFA500', '0xF14668', '0x77D970', '0x1597E5', '0x396EB0', '0xB8405E']

[512, 1024, 2048, 4096, 8192, 16384, 65536, 131072, 262144]
['0x325288', '0x916BBF', '0xFFA500', '0xF14668', '0x77D970', '0x1597E5', '0x396EB0', '0xB8405E', '0x39A388']

[1024, 2048, 4096, 8192, 16384, 65536, 131072, 262144, 524288]
['0x916BBF', '0xFFA500', '0xF14668', '0x77D970', '0x1597E5', '0x396EB0', '0xB8405E', '0x39A388', '0x325288']

*/

    console.log('v',lstValue)
    console.log('c',lstColor)
    if (v > 524288) { //16384 //262144
        lstValue = [512, 1024, 2048, 4096, 8192, 16384, 65536, 131072, 262144];
        lstColor = ['0x325288', '0x916BBF', '0xFFA500', '0xF14668', '0x77D970', '0x1597E5', '0x396EB0', '0xB8405E', '0x39A388'];
    }
    //console.log('после',lstValue)


    for (let i = 0; i < lstValue.length; i++) {
        if (lstValue[i] === v) {
            bn.list[0].tint = lstColor[i]
        }
    }


    SaveHSCore(v, scene);


    if (v < 1000) {
        bn.list[1].updateText(v)
    }
    if (v > 1000 && v < 1000000) {
        v_show = Math.trunc(v / 1000)
        bn.list[1].updateText(v_show + 'K')
    }
    if (v > 1000000 && v < 1000000000) {
        v_show = Math.trunc(v / 1000000)
        bn.list[1].updateText(v_show + 'M')
    }

    if (v > 1000000000 && v < 1000000000000) {
        v_show = Math.trunc(v / 1000000000)
        bn.list[1].updateText(v_show + 'B')
    }

    if (v > 1000000000000) {
        v_show = Math.trunc(v / 1000000000000)
        bn.list[1].updateText(v_show + 'T')
    }

    if (bn.list[1].text.length > 3) {
        bn.list[1].setFontSize(36);
    }


    bn.data.set('value', v)
    fieldArray[i][j].tileValue = v



    if (topObj(i, j) == null || topObj(i, j).tileValue !== 0) {
        checkMerge(scene, obj)
    }

    //console.log(fieldArray)






    /*
    try {
        await axios.post(GAMEOPTIONS.API + '/user-board/', {
            uid: userId,
            board: dashBoardUser,
        }, {
            //headers
        });
    } catch (e) {
        console.log('err SaveHSCore, no connection')
    }
    */

    //console.log(fieldArray)

}

function animateScore(scene, startValue, endValue) {
    let currentValue = startValue;
    scene.tweens.addCounter({
        from: startValue,
        to: endValue,
        duration: 1000,
        onUpdate: function (tween) {
            currentValue = Math.floor(tween.getValue());
            txtScore.updateText(currentValue);
        },
        onComplete: function () {
            txtScore.updateText(endValue);
        }
    });
}

async function SaveHSCore(v, scene) {
    const isOnline = navigator.onLine;

    if (isOnline) {
        //console.log("online");
    } else {
        await eventBus.emit('page', 'noConnect');
        scene.scene.pause();
    }

    //console.log('SaveHSCore', v)
    step++;
    let totalScoreRemote = 0;
    try {
        totalScoreRemote = (await axios.post(GAMEOPTIONS.API + '/save-score/', {
            step: step,
            v: v,
            d: number_diamond,
            uid: userId,
        }, {
            //headers
        })).data;
        totalScore = totalScoreRemote['totalScore'];
        //console.log('totalScore', totalScore)
        const tScoreTxt = numberFormat(totalScore)
        txtTotalScore.updateText(tScoreTxt)
        localStorage.setItem('totalScore', totalScore);
    } catch (e) {
        console.log('err SaveHSCore, no connection')
    }



    animateScore(scene, score, score + v);
    score += v;
    //console.log('score', score);
    if (score > hightScore) {
        hightScore = score; //hightScore * 1 + v;
        let hScoreTxt = numberFormat(hightScore);
        txtHightScore.updateText(hScoreTxt)
        localStorage.setItem('hscore', hightScore)
    }

    txtScore.updateText(score);



}

function SaveDiamond(scene, x, y) {
    let r = Random(1, 100); //вероятность выпадения кристаллов, default = 100
    let maxDiamonds = 5; // default = 5
    //console.log('r diamonds', r)
    if (r <= 20) { //25
        for (let i = 0; i < maxDiamonds; i++) {
            setTimeout(function () {
                if (number_diamond <= 300) { //default 150
                    let diamond = scene.add.image(x, y, 'diamond1').setScale(0.5)
                    x = x + Random(0, 5)
                    y = y + Random(0, 5)
                    scene.tweens.add({
                        targets: diamond,
                        props: {
                            x: {value: 205, duration: 500, ease: 'Bounce'},
                            y: {value: scene.scale.height - 200, duration: 500, ease: 'Bounce'}
                        },
                        onComplete: function () {
                            diamond.destroy()
                        }
                    })
                    number_diamond++;
                    txtDiamond.updateText(number_diamond)
                }
            }, i * 100)
        }
    }
    //localStorage.setItem('diamond', number_diamond)
}

function FindAll(scene) {
    for (var j = 0; j < GAMEOPTIONS.colum; j++) {
        for (var i = 0; i < GAMEOPTIONS.row; i++) {
            let obj = fieldArray[i][j]
            if (i > 0 && obj.tileValue > 0 && topObj(i, j).tileValue === 0) {
                let end = getEndObject(j)
                fieldArray[i][j].tileValue = 0
                end.tileValue = obj.tileValue
                MoveObject(scene, obj.tileNumber, end.tile)
                return
            }
        }
    }
    startFill = false
}

function topObj(i, j) {
    if (i <= 0) return null
    return fieldArray[i - 1][j]
}

function leftObj(i, j) {
    if (j <= 0) return null
    return fieldArray[i][j - 1]
}

function rightObj(i, j) {
    if (j >= GAMEOPTIONS.colum) return null
    return fieldArray[i][j + 1]
}

//UI

function UIDiamond(scene) {
    number_diamond = 151; //localStorage.getItem('diamond')
    let b = scene.add.rectangle(0, 0, 150, 40).setStrokeStyle(0, 0xffffff); // lineWidth 2
    let d = new Block(scene, b.x + 16, b.y + 0, 'diamond1')

    d.preFX.addShine();

    txtDiamond = new CustomText(scene, b.x + 16, b.y + 40, 'popin', number_diamond, 30)
    let btnDiamond = new BlockNumber(scene, 200, scene.scale.height - 210, [b, d, txtDiamond]);
    if (isDesktop) {
        btnDiamond.setX(32);
        btnDiamond.setY(266);


    }


    btnDiamond.setSize(b.width, b.height)
}

function numberFormat(value) {
    let result = value;

    if (value > 1000 && value < 1000000) {
        result = (value / 1000).toFixed(1) + "K"
    }

    if (value >= 1000000 && value < 1000000000) {
        result = (value / 1000000).toFixed(1) + 'M'
    }

    if (value >= 1000000000 && value < 1000000000000) {
        result = (value / 1000000000).toFixed(1) + 'B'
    }

    if (value > 1000000000000) {
        result = (value / 1000000000000).toFixed(1) + 'T'
    }

    return result;
}

function UIHigthScore(scene) {
    const top = 800;
    hightScore = localStorage.getItem('hscore');
    let b = scene.add.rectangle(0, 0, 150, 40).setStrokeStyle(0, 0xffffff);
    let d = new Block(scene, b.x - 50, b.y, 'rec').setScale(0.64);
    d.preFX.addShine();
    //d.postFX.addShine();

    //d.preFX.addGlow();
    //d.postFX.addGlow();

    txtHightScore = new CustomText(scene, d.x + 100, d.y + 3, 'popin', numberFormat(hightScore), 30)
    txtHightScore.setLeftAlign();
    //txtHightScore.align = 'center'

    let btnDiamond = new BlockNumber(scene, 100, 130, [b, d, txtHightScore])
    btnDiamond.setSize(b.width, b.height);

    let d2 = new Block(scene, scene.scale.width / 2, 100, 'sth').setScale(0.92);
    d2.setX(scene.scale.width / 2)
    d2.preFX.addShine();
    //d2.postFX.addShine();
    //d2.preFX.addGlow('0xffcf47');


    let d3 = new Block(scene, scene.scale.width / 2 + 185, 133, 'crown'); //- txtTotalScore.width //сундк
    d3.preFX.addShine();
    d3.postFX.addShine();
    txtTotalScore = new CustomText(scene, scene.scale.width / 2 + 280, 133, 'popin', numberFormat(totalScore), 30);
    txtTotalScore.setLeftAlign();

}

function UIScore(scene) {
    txtScore = new CustomText(scene, scene.scale.width / 2, 164, 'popin', 0, 40, '0xffd65d');
    let t = scene.add.rectangle(scene.scale.width / 2, 200, scene.scale.width, 5, '0x40394A');
    let b = scene.add.rectangle(scene.scale.width / 2, 1000, scene.scale.width, 5, '0x40394A');
}

function UISound(scene) {

    let btnSoundBoder = new Block(scene, scene.scale.width - 70, 50, 'boder').setScale(0.3).setInteractive() //new Block(scene,650,120,'boder').setScale(0.3).setInteractive()
    let btnSound = new Block(scene, btnSoundBoder.x, btnSoundBoder.y, 'btnSoundOn').setScale(0.3);


    if (!check_sound) {
        btnSound.setTexture('btnSoundOff')
    }


    if (isDesktop) {
        btnSoundBoder.setY(276);
        btnSoundBoder.setScale(0.37);
        btnSoundBoder.setX(scene.scale.width - 74);

        btnSound.setY(276);
        btnSound.setScale(0.36);
        btnSound.setX(scene.scale.width - 74);
    }

    btnSoundBoder.on('pointerdown', function (pointer) {

        scene.tweens.add({
            targets: btnSound,
            scale: {from: btnSound.scale - 0.15, to: btnSound.scale},
            ease: 'Bounce',
            duration: 500,
            onComplete: function () {
                if (check_sound) {
                    scene.sound.stopAll();
                    check_sound = false
                    btnSound.setTexture('btnSoundOff')
                    localStorage.setItem('isSoundOff', true)
                } else {
                    check_sound = true
                    SoundPlay(scene, 'bg_music')
                    btnSound.setTexture('btnSoundOn')
                    localStorage.setItem('isSoundOff', false)
                }
            },
        })
    })
}

function checkGameOver(scene) {
    let gameover = true
    for (let i = 0; i < GAMEOPTIONS.colum; i++) {
        if (fieldArray[6][i].tileValue === 0) {
            return false
        }
    }
    if (gameover) {
        groupBlock.forEach(element => {
            //console.log(element.data.list.value)
            for (let i = 0; i < GAMEOPTIONS.colum; i++) {
                //console.log(fieldArray[6][i].tileValue)
                if (fieldArray[6][i].tileValue === element.data.list.value) {
                    gameover = false
                    return
                }
            }
        });
    }

    console.log('gameover', gameover)

    showGameOver(scene)


    //scene.scene.switch('game_menu');

    return gameover
}

function UIItem(scene) {

    //item 2 - avatar
    let user_name = new CustomText(scene, scene.scale.width / 2, 46, 'popin', localStorage.getItem('name'), 29) //имя
    // let user_card = new Block(scene, scene.scale.width / 2 - user_name.width / 2 - 30, 42, 'avatar').setScale(0.4)

    //item 1
    let btnHammer = new Block(scene, 80, scene.scale.height - 200, 'boder').setScale(0.3).setInteractive();
    if (isDesktop) {
        btnHammer.setX(52);
        btnHammer.setY(372);

    }

    let hammer_icon = new Block(scene, btnHammer.x, btnHammer.y, 'hammer').setScale(0.2)
    let diamond_icon = new Block(scene, btnHammer.x + 20, btnHammer.y + 54, 'diamond1').setScale(0.3)
    let txtHammer = new CustomText(scene, btnHammer.x - 15, btnHammer.y + 57, 'popin', '150', 20) //число молотков


    btnHammer.on('pointerdown', function (pointer) {
        use_hammer = true
        tw.BtnClickAnim(scene, hammer_icon, 'btnHammer')
    });


    let scaleIcons = 0.45;
    let textSize = 28;

    //item 0 - invite
    if (!isDesktop) {
        let btnInvite = new Block(scene, scene.scale.width - 80, scene.scale.height - 200, 'btnInvite_en').setScale(0.3).setInteractive()
        btnInvite.on('pointerdown', function (pointer) {
            tw.BtnClickAnim(scene, btnInvite, 'btnUsers')
        })
    }

    //item 3 - chat
    let chat_text = new CustomText(scene, 80, scene.scale.height - 20, 'popin', 'Chat', textSize) //имя
    let btnChat = new Block(scene, 80, scene.scale.height - 80, 'btnChat').setScale(scaleIcons).setInteractive()
    btnChat.on('pointerdown', function (pointer) {
        tw.BtnClickAnim(scene, btnChat, 'btnChat')
    })

    //item 4 - task
    let task_text = new CustomText(scene, btnChat.x + 140, scene.scale.height - 20, 'popin', 'Tasks', textSize)
    let btnTask = new Block(scene, btnChat.x + 140, scene.scale.height - 80, 'btnTask').setScale(scaleIcons).setInteractive()
    btnTask.on('pointerdown', function (pointer) {
        tw.BtnClickAnim(scene, btnTask, 'btnTask')
    })


    //item 5 - top - center
    let top_text = new CustomText(scene, scene.scale.width / 2, scene.scale.height - 20, 'popin', 'TOP', textSize)
    let btnTop = new Block(scene, scene.scale.width / 2, scene.scale.height - 80, 'btnTop').setScale(scaleIcons).setInteractive()
    btnTop.on('pointerdown', function (pointer) {
        tw.BtnClickAnim(scene, btnTop, 'btnTop')
    })

    if (isDesktop) {
        btnTop.setY(370); //266
        top_text.setY(btnTop.y + 46);
        btnTop.setX(scene.scale.width - 74);
        top_text.setX(scene.scale.width - 74)
    }

    //item 7 - Wallet
    let wallet_text = new CustomText(scene, scene.scale.width - 80, scene.scale.height - 20, 'popin', 'Wallet', textSize)
    let btnWallet = new Block(scene, scene.scale.width - 80, scene.scale.height - 80, 'btnWallet').setScale(scaleIcons).setInteractive()
    btnWallet.on('pointerdown', function (pointer) {
        tw.BtnClickAnim(scene, btnWallet, 'btnWallet');

    })

    //item 6 - Users
    const btnUsers = new Block(scene, btnWallet.x - 140, scene.scale.height - 80, 'btnUsers').setScale(scaleIcons).setInteractive();
    let users_text = new CustomText(scene, btnUsers.x, btnUsers.y + 60, 'popin', 'Friends', textSize)
    btnUsers.on('pointerdown', function (pointer) {
        tw.BtnClickAnim(scene, btnUsers, 'btnUsers')
    })

    if (isDesktop) {
        btnChat.setY(scene.scale.height - 90);
        chat_text.setY(scene.scale.height - 40);

        btnUsers.setY(scene.scale.height - 90);
        users_text.setY(scene.scale.height - 40);

        btnWallet.setY(scene.scale.height - 90);
        wallet_text.setY(scene.scale.height - 40);

        btnTask.setY(scene.scale.height - 90);
        task_text.setY(scene.scale.height - 40);
    }

}

function SoundPlay(scene, music_name) {
    if (!check_sound) return
    if (music_name === 'bg_music') {
        let music_bg = scene.sound.add(music_name)
        music_bg.play()
        music_bg.setLoop(true)
    } else {
        scene.sound.play(music_name);
    }

}

function createParticel(scene, e) {
    scene.add.particles(0, 0, 'block', {
        x: e.x,
        y: e.y,
        speed: {min: -600, max: 600},
        alpha: {min: 0, max: 0.5},
        angle: {min: 0, max: 360},
        scale: {start: 0.1, end: 0},
        blendMode: 'SCREEN',
        //active: false,
        frequency: 5,
        lifespan: 600,
        gravityY: 800,
        quantity: 3,
        // tint: e.tint,
        maxParticles: 15
    });
}








